import { render, staticRenderFns } from "./OverallCard.vue?vue&type=template&id=c7c40c86&scoped=true"
import script from "./OverallCard.vue?vue&type=script&lang=js"
export * from "./OverallCard.vue?vue&type=script&lang=js"
import style0 from "./OverallCard.vue?vue&type=style&index=0&id=c7c40c86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c40c86",
  null
  
)

export default component.exports